import { combineReducers } from 'redux'

import profileReducer from '../common/state/profile/reducer'
import { userReducer } from '../store/user/reducers'
import { utilesReducer } from '../store/utiles/reducers'

import game from './state/game/reducer'
import landReducer from './state/land/reducer'
import type { GameStateProps } from './state/game/state'
import type { LandState } from './state/land/state'
import type { MiningFactoryState } from './state/miningFactory/state'

// ✨ NEW: Import inventory and character reducers
import inventoryReducer from './state/inventory/reducer'
import characterReducer from './state/character/reducer'
import marketplaceReducer from './state/marketplace/reducer'
import miningFactoryReducer from './state/miningFactory/reducer'
import settingsReducer from './state/settings/reducer'
import pvpReducer from './state/pvp/reducer'
import notificationReducer from './state/notifications/reducer'
import mvmRosterReducer from './state/mvmRoster/reducer'
import mvmMarchLocksReducer from './state/mvmMarchLocks/reducer'

// ✨ NEW: Import castle reducers
import castle1Reducer from './state/castle1/reducer'
import castle2Reducer from './state/castle2/reducer'
import castle3Reducer from './state/castle3/reducer'
import castle4Reducer from './state/castle4/reducer'
import castle5Reducer from './state/castle5/reducer'
import missionReducer from './state/mission/reducer'
import type { Castle1State } from './state/castle1/state'
import type { Castle2State } from './state/castle2/state'
import type { Castle3State } from './state/castle3/state'
import type { Castle4State } from './state/castle4/state'
import type { Castle5State } from './state/castle5/state'
import type { PvPState } from './state/pvp/state'

export interface AppState {
  game: GameStateProps
  inventory: any // Will be properly typed
  character: any // Will be properly typed
  marketplace: any // Will be properly typed
  land: LandState
  miningFactory: MiningFactoryState
  castle1: Castle1State
  castle2: Castle2State
  castle3: Castle3State
  castle4: Castle4State
  castle5: Castle5State
  mission: ReturnType<typeof missionReducer>
  pvp: PvPState
}

import type { LoginState } from '../store/user/action-types'
import type { MvMRosterState } from './state/mvmRoster/state'
import type { MvMMarchLocksState } from './state/mvmMarchLocks/state'
import presenceReducer from './state/presence/reducer'
import type { PresenceState } from './state/presence/reducer'

export interface RootState {
  app: AppState
  userModule: LoginState
  utilesModule: any
  profile: any
  notifications: any
  mvmRoster: MvMRosterState
  mvmMarchLocks: MvMMarchLocksState
  /** Live online/offline edges from the presence socket (`presence:changed`). */
  presence: PresenceState
}

export default combineReducers({
  app: combineReducers({
    game,
    inventory: inventoryReducer,
    character: characterReducer,
    marketplace: marketplaceReducer,
    land: landReducer,
    miningFactory: miningFactoryReducer,
    settings: settingsReducer,
    castle1: castle1Reducer,
    castle2: castle2Reducer,
    castle3: castle3Reducer,
    castle4: castle4Reducer,
    castle5: castle5Reducer,
    mission: missionReducer,
    pvp: pvpReducer,
  }),
  userModule: userReducer,
  utilesModule: utilesReducer,
  profile: profileReducer,
  notifications: notificationReducer,
  mvmRoster: mvmRosterReducer,
  mvmMarchLocks: mvmMarchLocksReducer,
  presence: presenceReducer,
})
